import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LinkPage.css';
import Seo from '../components/Seo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRocket,
  faBoxOpen,
  faPalette,
  faChevronRight,
  faGlobe,
  faCalculator,
  faChartLine
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

export default function LinkPage() {
  const navigate = useNavigate();

  return (
    <>
      <Seo
        title="Links & Tools | Online Growth Club"
        description="Conversiegerichte link-in-bio pagina met lease-aanbod, gratis demo en rekentools die tijd besparen."
        path="/links"
      />

      <main className="linkpage-hero">
        <div className="lp-container">
          {/* Logo zoals navbar */}
          <Link to="/" className="navbar-brand d-flex align-items-center gap-2 lp-logo">
            <FontAwesomeIcon icon={faRocket} className="logo-icon text-orange" />
            <span className="logo-title">
              Online<span className="text-orange">Growth</span>Club
            </span>
          </Link>

          {/* Pitches bovenaan */}
          <h1 className="lp-title">Meer klanten, minder gedoe</h1>
          <p className="lp-subtitle">
            Websites, SEO, Ads en Branding, op leasebasis en groei-gericht.
          </p>

          <section className="lp-pitches">
            <a href="/contact" className="lp-pitch lp-pitch-accent">
              <div className="lp-pitch-icon">
                <FontAwesomeIcon icon={faChartLine} />
              </div>
              <div className="lp-pitch-copy">
                <h2>Lease je website vanaf €39,99 p/m</h2>
                <p>Professionele site zonder hoge startkosten. Snel online, inclusief basis-SEO en onderhoud.</p>
              </div>
              <FontAwesomeIcon icon={faChevronRight} className="chev" />
            </a>

            <a href="/contact" className="lp-pitch lp-pitch-primary">
              <div className="lp-pitch-icon">
                <FontAwesomeIcon icon={faPalette} />
              </div>
              <div className="lp-pitch-copy">
                <h2>Gratis demo design</h2>
                <p>Ontvang een visuele eerste opzet. Zie direct hoe jouw merk online kan groeien.</p>
              </div>
              <FontAwesomeIcon icon={faChevronRight} className="chev" />
            </a>
          </section>

          {/* Conversiegerichte knoppen */}
          <section className="lp-links">
            <a href="/" className="lp-btn lp-btn-primary">
              <FontAwesomeIcon icon={faBoxOpen} />
              <span>Bekijk onze diensten</span>
              <FontAwesomeIcon icon={faChevronRight} className="chev" />
            </a>

            <a href="/contact" className="lp-btn lp-btn-accent">
              <FontAwesomeIcon icon={faGlobe} />
              <span>Plan een gratis strategie-call</span>
              <FontAwesomeIcon icon={faChevronRight} className="chev" />
            </a>

            <button
              type="button"
              className="lp-btn lp-btn-ghost"
              onClick={() => navigate('/links/tools')}
            >
              <FontAwesomeIcon icon={faCalculator} />
              <span>Rekentools (bouw & offerte-diensten)</span>
              <FontAwesomeIcon icon={faChevronRight} className="chev" />
            </button>

            {/* Groene WhatsApp knop */}
            <a
              href="https://wa.me/31644109856"
              target="_blank"
              rel="noopener noreferrer"
              className="lp-btn lp-btn-whatsapp"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
              <span>Voor snelle vragen: WhatsApp ons</span>
              <FontAwesomeIcon icon={faChevronRight} className="chev" />
            </a>
          </section>

          {/* Onderste CTA */}
          <section className="lp-card lp-card-cta">
            <div className="lp-card-head">
              <div className="lp-card-icon">
                <FontAwesomeIcon icon={faCalculator} />
              </div>
              <h2 className="lp-card-title">Vrijblijvend sparren over de mogelijkheden</h2>
            </div>
            <p className="lp-card-lead">
              Wil je weten wat website lease, SEO en slimme rekentools voor jouw bedrijf betekenen?
              In een korte call verkennen we doelen, budget en de snelste route naar meer aanvragen.
            </p>
            <a href="/contact" className="lp-cta-big">
              Plan jouw gratis strategie-call
            </a>
          </section>
        </div>
      </main>
    </>
  );
}
